import { getListUsers, getListsInfo } from '../../firebase'; 
import { useState, useEffect } from 'react';

export default function ListInfoModal({ isOpen, onClose, listsId, listId, listSize }) {
  const [listUsers, setListUser] = useState("");
  const [listInfoObject, setListInfoObject] = useState({});

  useEffect(() => {
    const getUserData = async() => {
      const results = await getListUsers(listId);
      setListUser(results);
    }

    const getListInfo = async() => {
      const results = await getListsInfo(listsId, listId);
      setListInfoObject(results);
    }

    getUserData();
    getListInfo();
  }, [listId, listsId]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    onClose();
  }

  const shareList = (e) => {
    e.preventDefault();
    const shareLink = `https://www.movie-friends.com/list/${listId}`;
    
    if (shareLink !== undefined) {
      navigator.clipboard.writeText(shareLink);
      alert("List link copied to clipboard.")
    }
  }

  const listInfo = Object.values(listInfoObject);
  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <h1 className='item-title'>Info</h1>
        <p>List Creation Date: <span>{listInfo[0]}</span></p>
        <p>List Size: {listSize}</p>
        <p>List Link: <button className="mainPageButtons" onClick={shareList}>Share List</button></p>
        <h2 className='item-title'>Members</h2>
        <ul>
          {
            listUsers.map((username, index) => (
              <li key={index}>{username}</li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}
